//* import React, { useState, useContext } from 'react';
import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Slider from 'react-slick';
import { InnerPageSectionHeading } from './styles/SectionHeadline.styled';
import { SectionHeadingCenter } from './styles/SectionHeadingCenter.styled';
import {
  TabWrapper,
  ButtonTab,
  TabDescription,
  DescriptionSection,
  Spanpt,
  PdfButton,
  PdfText,
} from './styles/FacilitiesTabSection.styled';
import pdfIcon from '../images/pdficon.png';

import { Container } from './styles/Container.styled';
import { Button, ButtonInRight } from './styles/Button.styled';
import ThreeColumnTextContent from './ThreeColumnTextContent';
import Sprites from './Sprites';
import { NextArrow, PrevArrow } from './NextPrevArrow';

export default function TransportList({ data, id, dir }) {
  const { transportList, markerIcon } = data;
  const [toggleState, setToggleState] = useState(0);
  const handleNext = (curr, last) => setToggleState(+curr + 1 < +last ? +curr + 1 : +last);
  const handlePrev = (curr) => setToggleState(+curr - 1 > 0 ? +curr - 1 : 0);
  const viewwebsite = dir === 'ltr' ? 'VISIT WEBSITE' : 'تفضّل بزيارة الموقع الإلكتروني';
  const isBrowser = typeof window !== 'undefined';

  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3500,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          arrows: false,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 5,
          autoplay: false,
          arrows: true,
          nextArrow: <NextArrow handleNext={handleNext} />,
          prevArrow: <PrevArrow handlePrev={handlePrev} />,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          autoplay: false,
          arrows: true,
          nextArrow: <NextArrow handleNext={handleNext} />,
          prevArrow: <PrevArrow handlePrev={handlePrev} />,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          arrows: true,
          nextArrow: <NextArrow handleNext={handleNext} dir={dir} />,
          prevArrow: <PrevArrow handlePrev={handlePrev} dir={dir} />,
        },
      },
    ],
  };

  React.useEffect(() => {
    if (isBrowser) {
      const { hash } = window.location;
      switch (hash) {
        case '#dubai-taxi':
          setToggleState(1);
          break;
        case '#private-taxi':
          setToggleState(2);
          break;
        case '#driving-and-parking':
          setToggleState(3);
          break;
        default:
          setToggleState(0);
      }
    }
  }, []);

  const sectionCaption = dir === 'rtl' ? 'وسائل النقل المتاحة' : 'Your Transport Options';

  return (
    <InnerPageSectionHeading id={id} className="padding_tab_zero">
      <Container>
        <SectionHeadingCenter className="tabsection">
          <h2 dir={dir}>{sectionCaption}</h2>
        </SectionHeadingCenter>
      </Container>
      <Container>
        <TabWrapper dir={dir} className="tab_pddn_wrapper transport_tab">
          <Slider {...settings} dir={dir}>
            {transportList.map(({ content }, index) => (
              <ButtonTab
                className={toggleState === index ? 'tabs active-tabs' : 'tabs'}
                onClick={() => setToggleState(index)}
                dir={dir}
              >
                <Sprites name={content.iconTag} />
                <Spanpt dir={dir}>{content.title}</Spanpt>
              </ButtonTab>
            ))}
          </Slider>
        </TabWrapper>
      </Container>

      <TabDescription className="tabgroup_descp padnbtn_tabdesc" dir={dir}>
        {transportList.map(({ content }, index) => (
          <DescriptionSection
            className={toggleState === index ? 'content active-content' : 'content'}
          >
            <ThreeColumnTextContent markericon={markerIcon} data={{ ...content }} dir={dir} />

            {content.iconTag.match(/parking2/gi) ? (
              <ButtonInRight className="tab_tansportbutton" dir={dir}>
                <PdfButton dir={dir}>
                  <LazyLoadImage src={pdfIcon} />
                  <PdfText>
                    <a
                      href={content.transportModeWebsite}
                      target="_blank"
                      rel="noreferrer"
                      dir={dir}
                    >
                      Parking Map
                    </a>
                  </PdfText>
                </PdfButton>
              </ButtonInRight>
            ) : (
              !!content.transportModeWebsite && (
                <Container>
                  <ButtonInRight className="tab_tansportbutton" dir={dir}>
                    <Button
                      href={content.transportModeWebsite}
                      target="_blank"
                      stylevariant="black"
                      dir={dir}
                    >
                      {viewwebsite}
                    </Button>
                  </ButtonInRight>
                </Container>
              )
            )}
          </DescriptionSection>
        ))}
      </TabDescription>
    </InnerPageSectionHeading>
  );
}
